// extracted by mini-css-extract-plugin
export default {"watermark":"styles_watermark__7ymzu","watermarkText":"styles_watermarkText__QxhZr","animateWatermark":"styles_animateWatermark__Avk8i","logo":"styles_logo__tqnoI"};